const ALL = 'all'
const TW = 'tw'
const US = 'us'

const MENU_LIST = Object.freeze([
  { name: '全部', value: ALL },
  { name: '台股', value: TW },
  { name: '美股', value: US },
])

export {
  ALL,
  TW,
  US,
  MENU_LIST,
}
